// Same lists as server/lib/catalog.ts.
export const SERVICE_CATEGORIES = [
  "plumbing", "electrical", "hvac", "roofing", "handyman", "cleaning", "gardening",
  "pest_control", "pool_spa", "appliances", "smart_home", "locksmith", "other",
] as const;

export const HOME_STATUSES = ["lead", "entry_consent", "checkup_booked", "trial", "active", "suspended", "pending_transfer", "terminated"] as const;
export const VISIT_TYPES = ["entry", "periodic", "intensive", "incident", "verification", "welfare"] as const;
export const PRIORITIES = ["P1", "P2", "P3", "P4"] as const;
export const OCCUPANCY = ["occupied", "temporarily_unoccupied", "vacant"] as const;
export const HOME_ROLES = ["account_holder", "resident", "remote", "payer"] as const;
export const FREQUENCIES = ["every_visit", "monthly", "quarterly", "seasonal", "annual", "first_checkup", "event"] as const;
